import { Button, message, TableColumnType, TablePaginationConfig, TableProps } from "antd";
import { DRAWER_TYPE } from "./useDrawerConfig";
import { renderBoolean, renderImage } from "../../../../../components/TableHelpers/ColumnHelper";
import { Shrine } from "@a4b/api/src/modules/Temple/types";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { CopyOutlined } from "@ant-design/icons";

export default function useTableConfig<T>(
  setActiveDrawer: React.Dispatch<React.SetStateAction<DRAWER_TYPE | undefined>>,
  dataSource: T[],
  pagination: TablePaginationConfig,
  setPagination: React.Dispatch<React.SetStateAction<TablePaginationConfig>>,
  setDrawer: (Drawer: DRAWER_TYPE) => void
): TableProps<Shrine.AvatarPayload> {
  const { god_id = "" } = useParams();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const columns: TableColumnType<Shrine.AvatarPayload>[] = [
    {
      title: "Attachment",
      dataIndex: "attachment",
      render(value) {
        return renderImage(value?.url);
      },
    },
    {
      title: "Code",
      dataIndex: "code",
      render(value, record) {
        return (
          <div>
            <p>
              Id:{" "}
              <b>
                {record?.id}{" "}
                <CopyOutlined
                  style={{ fontSize: 20 }}
                  onClick={() => {
                    navigator.clipboard.writeText(record?.id!);
                    message.info("Id Copied", 3);
                  }}
                />
              </b>
            </p>
            <p>
              Code: <b>{value}</b>
            </p>
          </div>
        );
      },
    },
    { title: "Type", dataIndex: "type" },
    { title: "AccessType", dataIndex: "access_type" },
    { title: "Position", dataIndex: "position" },
    {
      title: "Names",
      dataIndex: "names",
      render(value) {
        return (
          <div>
            <p>default: <b>{value?.default}</b></p>
            <p>english: <b>{value?.english}</b></p>
          </div>
        );
      },
    },
    {
      title: "Attachment English",
      dataIndex: "metadata",
      render(value) {
        return renderImage(value?.share_media?.en?.url);
      },
    },
    {
      title: "Attachment Hindi",
      dataIndex: "metadata",
      render(value) {
        return renderImage(value?.share_media?.hi?.url);
      },
    },
    { title: "Status", dataIndex: "active", render: renderBoolean },
    {
      title: "Actions",
      dataIndex: "id",
      render(value) {
        return (
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
            <Button
              type="link"
              onClick={() => {
                navigate(`/shrine/gods/${god_id}/avatars/${value}?${searchParams.toString()}`);
              }}
            >
              Edit
            </Button>
            <Button
              type="link"
              onClick={() => {
                const sp = new URLSearchParams(searchParams.toString());
                sp.set("action", "clone");
                navigate(`/shrine/gods/${god_id}/avatars/${value}?${sp.toString()}`);
              }}
            >
              Clone
            </Button>
          </div>
        );
      },
    },
  ];

  const tableOnChange = (nextPagination: TablePaginationConfig) => {
    setPagination(nextPagination);
  };

  return {
    columns,
    // @ts-ignore
    dataSource,
    pagination,
    onChange: tableOnChange,
    rowKey: "id",
  };
}
